import { BadgeCheck, FileText, Grid, User } from "lucide-react";

export const COMPANY_DETAIL_TABS = [
    { key: "overview", title: "Overview", startIcon: <Grid size={16} /> },
    { key: "profile", title: "Profile", startIcon: <User size={16} /> },
    { key: "posts", title: "Posts", startIcon: <FileText size={16} /> },
    { key: "verifications", title: "Verifications", startIcon: <BadgeCheck size={16} /> },
];

export const COMPANY_DETAIL_PROFILE_TABS = [
    { key: "basic-info", title: "Basic Information" },
    { key: "products", title: "Products" },
    { key: "awards", title: "Awards" },
    { key: "certifications", title: "Certifications" },
    { key: "services", title: "Services" },
    { key: "portfolios", title: "Portfolios" },
    { key: "group-buy-offers", title: "Group Buy Offers" },
];
